import { Button, styled } from "@mui/material";
import { tokens } from "@/tokens";

export const StyledButton = styled(Button)(() => ({
  fontSize: tokens.fontSize.sm2,
  fontWeight: tokens.fontWeight.bold,
  borderRadius: tokens.radius.md,
  boxShadow: 'none',
  height: 34,
  paddingLeft: 16,
  paddingRight: 16,
  backgroundColor: tokens.brand.primary,
  '&:hover': {
    backgroundColor: tokens.brand.primaryHover,
    boxShadow: 'none',
  },
}));
